export default "__VITE_ASSET__o9Yp_K6J__"